import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateUpdateNoteEntity } from '../../domain/entities/CreateUpdateNoteEntity'
import { OrderNoteType } from '../../domain/enums/OrderNoteType'

export class CreateUpdateNoteModel extends CreateUpdateNoteEntity {
  adminType= OrderNoteType.DELIVERY
  note = ''

  constructor(dataDto: CreateUpdateNoteEntity) {
    super()
    mapEntityProperties<CreateUpdateNoteModel>(this, dataDto)
  }
}
